import { useState, useEffect, useMemo } from 'react';
import { debounce } from 'global/lib/lodash';
import { useScreen } from '../styles';

function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
  };
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getSize());
  const screen = useScreen();

  function handleResize() {
    setWindowSize(getSize());
  }

  const debouncedChangeHandler = useMemo(() => debounce(handleResize, 200), []);

  useEffect(() => {
    window.addEventListener('resize', debouncedChangeHandler);
    return () => {
      window.removeEventListener('resize', debouncedChangeHandler);
    };
  }, []);

  return {
    ...screen,
    windowSize,
  };
}
